export default {
  fa: {
    expired: 'نشست شما تمام شده است؛ دوباره وارد شوید.',
    forbidden: 'برای این کار دسترسی ندارید.',
    allLanguages: 'همه زبان‌ها',
    language_fa: 'فارسی',
    language_en: 'انگلیسی',
    language_ar: 'عربی',
    subtitle: 'دیدگاه‌ها را بررسی کنید و پاسخ‌های رسمی را از همین‌جا بنویسید.',
    onPage: 'دیدگاه در این صفحه',
    more: 'گزینه‌های بیشتر',
    postReference: 'شناسهٔ پست',
    reasonPlaceholder: 'در صورت نیاز، دلیل تصمیم را یادداشت کنید…',
    edit: 'ویرایش متن',
    saveEdit: 'ثبت ویرایش',
    editReason: 'دلیل ویرایش (الزامی، داخلی)',
    editPolicy: 'متن مهمان یا کاربر پس از ویرایش دوباره وارد صف بررسی می‌شود. ویرایش پاسخ رسمی وضعیت فعلی را حفظ می‌کند. برچسب ویرایش ادمین عمومی است.',
    pin: 'پین کردن',
    unpin: 'برداشتن پین',
    pinned: 'پین‌شده',
    edited: 'ویرایش‌شده توسط کاربر',
    editedAdmin: 'ویرایش‌شده توسط ادمین',
    title: 'دیدگاه پست‌ها',
    legacy: 'دیدگاه پزشکان',
    all: 'همه وضعیت‌ها',
    pending: 'در انتظار بررسی',
    approved: 'تأییدشده',
    rejected: 'ردشده',
    search: 'جستجو در متن',
    language: 'زبان دیدگاه',
    post: 'پست',
    postKind_week: 'هفته بارداری',
    postKind_category: 'صفحه دسته‌بندی',
    openPost: 'مشاهدهٔ مطلب در تب جدید',
    postLinkUnavailable: 'لینک عمومی این مطلب در دسترس نیست.',
    author: 'نویسنده',
    text: 'دیدگاه',
    status: 'وضعیت',
    approve: 'تأیید',
    reject: 'رد',
    reply: 'پاسخ رسمی',
    send: 'ارسال پاسخ',
    cancel: 'انصراف',
    previous: 'قبلی',
    next: 'بعدی',
    page: 'صفحه',
    empty: 'دیدگاهی پیدا نشد.',
    failed: 'عملیات انجام نشد؛ دوباره تلاش کنید.',
    saved: 'عملیات ثبت شد.',
    reason: 'دلیل بررسی (داخلی)',
    guest: 'مهمان',
    admin: 'ادمین',
    user: 'کاربر',
    reports: 'گزارش',
    thread: 'گفتگو',
    clear: 'نمایش همه',
    replyTo: 'در پاسخ به',
    approveFirst: 'برای پاسخ، ابتدا دیدگاه و والدهای آن را تأیید کنید.',
    disabled: 'این قابلیت هنوز فعال نشده است.',
    load: 'نمایش دیدگاه‌ها',
    loading: 'در حال دریافت…',
    changed: 'دیدگاه تغییر کرده است؛ لیست را تازه کنید. متن ویرایش شما حفظ شده است.',
    postId: 'شناسه فنی مطلب (اختیاری)',
    advancedFilters: 'فیلترهای بیشتر',
    activePostFilter: 'فیلتر مطلب فعال است',
    postUnavailable: 'عنوان مطلب در دسترس نیست',
    addLink: 'افزودن یا ویرایش لینک',
    linkText: 'متن لینک',
    linkUrl: 'نشانی لینک',
    applyLink: 'ثبت لینک',
    removeLink: 'برداشتن لینک',
    linkHint: 'بخشی از متن را انتخاب کنید یا متن لینک را وارد کنید.',
    invalidLink: 'نشانی لینک معتبر نیست. فقط لینک داخلی سایت یا نشانی http/https پذیرفته می‌شود.',
    preview: 'پیش‌نمایش پاسخ',
  },
  en: {
    expired: 'Your session expired. Please sign in again.',
    forbidden: 'You do not have permission for this action.',
    allLanguages: 'All languages',
    language_fa: 'Persian',
    language_en: 'English',
    language_ar: 'Arabic',
    subtitle: 'Review comments and send official replies in one place.',
    onPage: 'comments on this page',
    more: 'More options',
    postReference: 'Post reference',
    reasonPlaceholder: 'Add a note about your decision, if needed…',
    edit: 'Edit text',
    saveEdit: 'Save edit',
    editReason: 'Edit reason (required, internal)',
    editPolicy: 'Guest/user edits return to review. Official reply edits keep their current status. Moderator edits are publicly labeled.',
    pin: 'Pin',
    unpin: 'Unpin',
    pinned: 'Pinned',
    edited: 'Edited by user',
    editedAdmin: 'Edited by moderator',
    title: 'Post comments',
    legacy: 'Doctor comments',
    all: 'All statuses',
    pending: 'Pending review',
    approved: 'Approved',
    rejected: 'Rejected',
    search: 'Search text',
    language: 'Comment language',
    post: 'Post',
    postKind_week: 'Pregnancy week',
    postKind_category: 'Category page',
    openPost: 'Open post in a new tab',
    postLinkUnavailable: 'A public link is not available for this post.',
    author: 'Author',
    text: 'Comment',
    status: 'Status',
    approve: 'Approve',
    reject: 'Reject',
    reply: 'Official reply',
    send: 'Send reply',
    cancel: 'Cancel',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    empty: 'No comments found.',
    failed: 'Operation failed. Please retry.',
    saved: 'Saved.',
    reason: 'Review reason (internal)',
    guest: 'Guest',
    admin: 'Admin',
    user: 'User',
    reports: 'Reports',
    thread: 'Conversation',
    clear: 'Show all',
    replyTo: 'Replying to',
    approveFirst: 'Approve this comment and its parents before replying.',
    disabled: 'This feature has not been enabled.',
    load: 'Show comments',
    loading: 'Loading…',
    changed: 'The comment changed. Refresh the list; your edit draft is preserved.',
    postId: 'Technical post ID (optional)',
    advancedFilters: 'More filters',
    activePostFilter: 'Post filter active',
    postUnavailable: 'Post title unavailable',
    addLink: 'Add or edit link',
    linkText: 'Link text',
    linkUrl: 'Link URL',
    applyLink: 'Apply link',
    removeLink: 'Remove link',
    linkHint: 'Select text or enter the link text.',
    invalidLink: 'Enter a valid internal link or an http/https URL.',
    preview: 'Reply preview',
  },
  ar: {
    expired: 'انتهت الجلسة؛ سجل الدخول مجددًا.',
    forbidden: 'لا تملك صلاحية لهذا الإجراء.',
    allLanguages: 'كل اللغات',
    language_fa: 'الفارسية',
    language_en: 'الإنجليزية',
    language_ar: 'العربية',
    subtitle: 'راجع التعليقات واكتب الردود الرسمية من هنا.',
    onPage: 'تعليقات في هذه الصفحة',
    more: 'خيارات إضافية',
    postReference: 'معرّف المنشور',
    reasonPlaceholder: 'أضف ملاحظة حول قرارك عند الحاجة…',
    edit: 'تعديل النص',
    saveEdit: 'حفظ التعديل',
    editReason: 'سبب التعديل (إلزامي، داخلي)',
    editPolicy: 'تعود تعديلات الضيف والمستخدم للمراجعة. تحتفظ الردود الرسمية بحالتها. تُعرض علامة تعديل المشرف للجميع.',
    pin: 'تثبيت',
    unpin: 'إلغاء التثبيت',
    pinned: 'مثبت',
    edited: 'عدّله المستخدم',
    editedAdmin: 'عدّله المشرف',
    title: 'تعليقات المنشورات',
    legacy: 'تعليقات الأطباء',
    all: 'كل الحالات',
    pending: 'بانتظار المراجعة',
    approved: 'مقبول',
    rejected: 'مرفوض',
    search: 'البحث في النص',
    language: 'لغة التعليق',
    post: 'المنشور',
    postKind_week: 'أسبوع الحمل',
    postKind_category: 'صفحة التصنيف',
    openPost: 'عرض المنشور في علامة تبويب جديدة',
    postLinkUnavailable: 'الرابط العام لهذا المنشور غير متاح.',
    author: 'الكاتب',
    text: 'التعليق',
    status: 'الحالة',
    approve: 'موافقة',
    reject: 'رفض',
    reply: 'رد رسمي',
    send: 'إرسال الرد',
    cancel: 'إلغاء',
    previous: 'السابق',
    next: 'التالي',
    page: 'الصفحة',
    empty: 'لا توجد تعليقات.',
    failed: 'تعذرت العملية. حاول مجدداً.',
    saved: 'تم الحفظ.',
    reason: 'سبب المراجعة (داخلي)',
    guest: 'ضيف',
    admin: 'مشرف',
    user: 'مستخدم',
    reports: 'بلاغات',
    thread: 'المحادثة',
    clear: 'عرض الكل',
    replyTo: 'رد على',
    approveFirst: 'وافق على التعليق والتعليقات السابقة قبل الرد.',
    disabled: 'لم يتم تفعيل هذه الميزة بعد.',
    load: 'عرض التعليقات',
    loading: 'جارٍ التحميل…',
    changed: 'تغيّر التعليق. حدّث القائمة؛ تم الاحتفاظ بمسودة التعديل.',
    postId: 'المعرّف التقني للمنشور (اختياري)',
    advancedFilters: 'فلاتر إضافية',
    activePostFilter: 'فلتر المنشور مفعّل',
    postUnavailable: 'عنوان المنشور غير متاح',
    addLink: 'إضافة الرابط أو تعديله',
    linkText: 'نص الرابط',
    linkUrl: 'رابط URL',
    applyLink: 'تطبيق الرابط',
    removeLink: 'إزالة الرابط',
    linkHint: 'حدد النص أو أدخل نص الرابط.',
    invalidLink: 'أدخل رابطًا داخليًا صالحًا أو رابط http/https.',
    preview: 'معاينة الرد',
  },
}
